import React from 'react';
import '../styles/HowItWorks.css';

const steps = [
  {
    number: '1',
    colour: 'blue',
    title: 'Set Up Your Company',
    desc: 'Create your company account, add teams and configure your employees in minutes. No technical expertise needed.',
  },
  {
    number: '2',
    colour: 'green',
    title: 'Complete Surveys',
    desc: 'Employees get gentle push notifications to complete a 30 second survey via the Zella mobile app.',
  },
  {
    number: '3',
    colour: 'orange',
    title: 'Get Insights',
    desc: 'Instantly view team fatigue scores, happiness trends, and alerts on your dashboard. Generate PDF reports for leadership.',
  },
];

function HowItWorks() {
  return (
    <section className="how-it-works" id="how-it-works">
      <div className="section-container">
        <div className="section-header">
          <p className="how-it-works-subtitle">Get up and running with Zella in three simple steps.</p>
        </div>

        <div className="steps">
          {steps.map(({ number, colour, title, desc }, i) => (
            <React.Fragment key={number}>
              <div className="step">
                <div className={`step-number ${colour}`}>{number}</div>
                <h3>{title}</h3>
                <p>{desc}</p>
              </div>
              {i === 0 && <div className="step-connector green-to-blue" aria-hidden="true" />}
              {i === 1 && <div className="step-connector blue-to-orange" aria-hidden="true" />}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
